import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '11.8799 5.2521'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M22.3399 1.34717C22.3399 1.34717 18.6399 2.57715 11.8799 2.57715C5.11993 2.57715 1.41992 1.34717 1.41992 1.34717C5.25992 7.92717 9.41992 9.1571 11.8699 9.1571C14.3299 9.1571 18.4999 7.92717 22.3399 1.34717Z"
          fill="white"
          stroke={outline}
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
    </g>
  )
}
